import { HiPencil } from 'react-icons/hi'
import { RxCross2 } from 'react-icons/rx'
import { FcCheckmark } from 'react-icons/fc'
import { BsHouse } from "react-icons/bs";
import { PiShareNetwork } from "react-icons/pi";
import { IoMdBook } from "react-icons/io";
import { FcAcceptDatabase } from "react-icons/fc";
import { VscMultipleWindows } from "react-icons/vsc";
import { HiOutlineWrench } from "react-icons/hi2";
import { PiFactory } from "react-icons/pi";
import { BsTruck } from "react-icons/bs";
import { IoExtensionPuzzleOutline } from "react-icons/io5";
import { CgComment } from "react-icons/cg";
import { GoFile } from "react-icons/go";
import { FaEye } from "react-icons/fa6";
import { IoMdEyeOff } from "react-icons/io";
import { LuFolderCode } from 'react-icons/lu';





const withProps = IconComponent => props => <IconComponent {...props} />

const sidebarIconsAdmin = IconSidebarAdmin => props => (
  <IconSidebarAdmin size={27} color="black" {...props} />
)

const sidebarIcons = IconSidebar => props => (
  <IconSidebar size={30} color="black" {...props} />
)


export const IconPencil = withProps(HiPencil)
export const IconCross = withProps(RxCross2)
export const IconCheck = withProps(FcCheckmark)
export const IconEye = withProps(FaEye)
export const IconEyeOff = withProps(IoMdEyeOff)

export const IconCode = withProps(LuFolderCode)

export const IconHouse = sidebarIconsAdmin(BsHouse)
export const IconActivities = sidebarIconsAdmin(PiShareNetwork)
export const IconArticle = sidebarIconsAdmin(IoMdBook)

export const IconData = sidebarIcons(FcAcceptDatabase)
export const IconBimLinks = sidebarIcons(GoFile )
export const IconTypes = sidebarIcons(VscMultipleWindows )
export const IconArticles = sidebarIcons(HiOutlineWrench)
export const IconFactory = sidebarIcons(PiFactory)
export const IconTransport = sidebarIcons(BsTruck)
export const IconMount = sidebarIcons(IoExtensionPuzzleOutline)
export const IconReview = sidebarIcons(CgComment)
export const IconSummary = sidebarIcons(IoMdBook)
